import o, { useState as I } from "react";
import { c as m, t as g } from "./useKeyDown-88662051.mjs";
import { D as S } from "./app-51178863.mjs";
import { L as j } from "./LinkPreviewCard-45620bb4.mjs";
import { L } from "./Link-460da2fc.mjs";
import { I as x } from "./Image-be3826ec.mjs";
import { B } from "./Button-eec2778c.mjs";
import { B as f } from "./useClickOutside-55c64a80.mjs";
import "./CallToAction-b7ee6480.mjs";
import "./Icon-e01b6482.mjs";
import "./LinkContext-0c83848a.mjs";
import "./ImageContext-57256dc1.mjs";
function T(r, t) {
  if (r == null)
    return {};
  var e = A(r, t), n, a;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(r);
    for (a = 0; a < s.length; a++)
      n = s[a], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(r, n) && (e[n] = r[n]);
  }
  return e;
}
function A(r, t) {
  if (r == null)
    return {};
  var e = {}, n = Object.keys(r), a, s;
  for (s = 0; s < n.length; s++)
    a = n[s], !(t.indexOf(a) >= 0) && (e[a] = r[a]);
  return e;
}
function b() {
  return b = Object.assign || function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e)
        Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, b.apply(this, arguments);
}
function _(r, t) {
  var e = Object.keys(r);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(r);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(r, a).enumerable;
    })), e.push.apply(e, n);
  }
  return e;
}
function y(r) {
  for (var t = 1; t < arguments.length; t++) {
    var e = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _(Object(e), !0).forEach(function(n) {
      G(r, n, e[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(e)) : _(Object(e)).forEach(function(n) {
      Object.defineProperty(r, n, Object.getOwnPropertyDescriptor(e, n));
    });
  }
  return r;
}
function G(r, t, e) {
  return t in r ? Object.defineProperty(r, t, { value: e, enumerable: !0, configurable: !0, writable: !0 }) : r[t] = e, r;
}
const M = {
  breakpointCols: void 0,
  // optional, number or object { default: number, [key: number]: number }
  className: void 0,
  // required, string
  columnClassName: void 0,
  // optional, string
  // Any React children. Typically an array of JSX items
  children: void 0,
  // Custom attributes, however it is advised against
  // using these to prevent unintended issues and future conflicts
  // ...any other attribute, will be added to the container
  columnAttrs: void 0,
  // object, added to the columns
  // Deprecated props
  // The column property is deprecated.
  // It is an alias of the `columnAttrs` property
  column: void 0
}, v = 2;
class k extends o.Component {
  constructor(t) {
    super(t), this.reCalculateColumnCount = this.reCalculateColumnCount.bind(this), this.reCalculateColumnCountDebounce = this.reCalculateColumnCountDebounce.bind(this);
    let e;
    this.props.breakpointCols && this.props.breakpointCols.default ? e = this.props.breakpointCols.default : e = parseInt(this.props.breakpointCols) || v, this.state = {
      columnCount: e
    };
  }
  componentDidMount() {
    this.reCalculateColumnCount(), window && window.addEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  componentDidUpdate() {
    this.reCalculateColumnCount();
  }
  componentWillUnmount() {
    window && window.removeEventListener("resize", this.reCalculateColumnCountDebounce);
  }
  reCalculateColumnCountDebounce() {
    if (!window || !window.requestAnimationFrame) {
      this.reCalculateColumnCount();
      return;
    }
    window.cancelAnimationFrame && window.cancelAnimationFrame(this._lastRecalculateAnimationFrame), this._lastRecalculateAnimationFrame = window.requestAnimationFrame(() => {
      this.reCalculateColumnCount();
    });
  }
  reCalculateColumnCount() {
    const t = window && window.innerWidth || 1 / 0;
    let e = this.props.breakpointCols;
    typeof e != "object" && (e = {
      default: parseInt(e) || v
    });
    let n = 1 / 0, a = e.default || v;
    for (let s in e) {
      const l = parseInt(s);
      l > 0 && t <= l && l < n && (n = l, a = e[s]);
    }
    a = Math.max(1, parseInt(a) || 1), this.state.columnCount !== a && this.setState({
      columnCount: a
    });
  }
  itemsInColumns() {
    const t = this.state.columnCount, e = new Array(t), n = o.Children.toArray(this.props.children);
    for (let a = 0; a < n.length; a++) {
      const s = a % t;
      e[s] || (e[s] = []), e[s].push(n[a]);
    }
    return e;
  }
  renderColumns() {
    const {
      column: t,
      columnAttrs: e = {},
      columnClassName: n
    } = this.props, a = this.itemsInColumns(), s = `${100 / a.length}%`;
    let l = n;
    l && typeof l != "string" && (this.logDeprecated('The property "columnClassName" requires a string'), typeof l > "u" && (l = "my-masonry-grid_column"));
    const i = y(y(y({}, t), e), {}, {
      style: y(y({}, e.style), {}, {
        width: s
      }),
      className: l
    });
    return a.map((u, c) => /* @__PURE__ */ o.createElement("div", b({}, i, {
      key: c
    }), u));
  }
  logDeprecated(t) {
    console.error("[Masonry]", t);
  }
  render() {
    const t = this.props, {
      // ignored
      children: e,
      breakpointCols: n,
      columnClassName: a,
      columnAttrs: s,
      column: l,
      // used
      className: i
    } = t, u = T(t, ["children", "breakpointCols", "columnClassName", "columnAttrs", "column", "className"]);
    let c = i;
    return typeof i != "string" && (this.logDeprecated('The property "className" requires a string'), typeof i > "u" && (c = "my-masonry-grid")), /* @__PURE__ */ o.createElement("div", b({}, u, {
      className: c
    }), this.renderColumns());
  }
}
k.defaultProps = M;
const H = "masonry-grid", F = "desktop", W = "masonry-grid__column", $ = "masonry-grid__card-container", U = "masonry-card__image-container", h = {
  masonryGrid: H,
  desktop: F,
  masonryGridColumn: W,
  masonryGridCardContainer: $,
  masonryCardImageContainer: U
}, q = "masonry-card", R = "masonry-card__title", z = "masonry-card__image-container", K = "masonry-card--pressed", J = "desktop", Q = "masonry-card__save-button", V = "masonry-card__save-button--hidden", X = "masonry-card__info", Y = "masonry-card__date", Z = "masonry-card__date--hidden", ee = "masonry-card__title--hidden", te = "masonry-card__description", ne = "masonry-card__description--hidden", d = {
  masonryCard: q,
  masonryCardTitle: R,
  masonryCardImageContainer: z,
  masonryCardPressed: K,
  desktop: J,
  masonryCardSaveButton: Q,
  masonryCardSaveButtonHidden: V,
  masonryCardInfo: X,
  masonryCardDate: Y,
  masonryCardDateHidden: Z,
  masonryCardTitleHidden: ee,
  masonryCardDescription: te,
  masonryCardDescriptionHidden: ne
}, re = ({
  title: r,
  description: t,
  date: e,
  link: n,
  linkLocale: a,
  showSaveButton: s = !1,
  isSaved: l = !1,
  image: i,
  onClick: u
}) => {
  const [c, p] = I(!1);
  return /* @__PURE__ */ o.createElement(
    L,
    {
      className: m(
        d.masonryCard,
        c && d.masonryCardPressed
      ),
      href: n,
      locale: a,
      "data-testid": "masonry-card",
      disableLinkTextStyle: !0,
      onMouseDown: () => p(!0),
      onMouseUp: () => p(!1),
      onMouseLeave: () => p(!1)
    },
    /* @__PURE__ */ o.createElement(o.Fragment, null, /* @__PURE__ */ o.createElement(
      "div",
      {
        className: m(d.masonryCardImageContainer),
        "data-testid": "masonry-image"
      },
      i && /* @__PURE__ */ o.createElement(
        x,
        {
          credits: i.credits,
          src: i.src,
          width: i.width,
          height: i.height,
          altText: i.altText,
          imageLoader: i.imageLoader,
          styling: i.styling
        }
      ),
      /* @__PURE__ */ o.createElement(
        "div",
        {
          className: m(
            d.masonryCardSaveButton,
            !s && d.masonryCardSaveButtonHidden
          )
        },
        /* @__PURE__ */ o.createElement(
          B.Save,
          {
            iconFilled: l,
            onMouseDown: (C) => C.stopPropagation(),
            "data-testid": "masonry-save-button",
            onClick: (C) => {
              C?.preventDefault(), u?.();
            }
          }
        )
      )
    ), /* @__PURE__ */ o.createElement(
      "div",
      {
        className: m(d.masonryCardInfo),
        "data-testid": "masonry-content"
      },
      /* @__PURE__ */ o.createElement(
        "p",
        {
          className: m(
            d.masonryCardDate,
            g.textsLeadText,
            e === void 0 && d.masonryCardDateHidden
          )
        },
        `Date ${e}`
      ),
      /* @__PURE__ */ o.createElement("div", { className: d.masonryCardTitle }, /* @__PURE__ */ o.createElement("p", { className: g.textsComponentTitleBold }, r)),
      /* @__PURE__ */ o.createElement(
        "p",
        {
          className: m(
            d.masonryCardDescription,
            g.textsLeadText
          )
        },
        t
      )
    ))
  );
}, ae = {
  default: 2,
  [S.md - 1]: 1
};
function he(r) {
  const { variants: t } = r;
  return /* @__PURE__ */ o.createElement(
    f,
    {
      "data-testid": "masonry-block",
      topPadding: f.Padding.NONE,
      bottomPadding: f.Padding.LARGE
    },
    /* @__PURE__ */ o.createElement(f.Content, { "data-testid": "masonry-content" }, /* @__PURE__ */ o.createElement(
      k,
      {
        breakpointCols: ae,
        className: m(h.masonryGrid),
        columnClassName: m(h.masonryGridColumn),
        "data-testid": "masonry"
      },
      t && t.length && t.map((e, n) => {
        const { masonry: a, linkPreview: s } = e;
        if (a)
          return /* @__PURE__ */ o.createElement(
            "div",
            {
              key: n,
              className: m(h.masonryGridCardContainer)
            },
            /* @__PURE__ */ o.createElement(re, { ...a })
          );
        if (s) {
          const { card: l, hasImages: i, hasSaveButton: u } = s, {
            cardIntroText: c,
            cardTitle: p,
            imageProps: C,
            link: w,
            linkLabel: D,
            linkLocale: O,
            linkDescription: P,
            onSave: E,
            isSaved: N
          } = l;
          return /* @__PURE__ */ o.createElement(
            "div",
            {
              className: m(h.masonryGridCardContainer),
              key: l.link
            },
            /* @__PURE__ */ o.createElement(
              j,
              {
                key: w,
                cardIntroText: c,
                cardTitle: p,
                imageProps: C,
                link: w,
                linkDescription: P,
                linkLocale: O,
                hasImages: i,
                hasSaveButton: u,
                linkLabel: D,
                onSave: E,
                isSaved: N
              }
            )
          );
        }
      })
    ))
  );
}
export {
  he as MasonryGrid
};
//# sourceMappingURL=Masonry.js.map
